// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1RyH4","selects":"Documents_selects__1FZ3C"};